import { render, staticRenderFns } from "./ModifyLoanPayment.vue?vue&type=template&id=a60927fc"
import script from "./ModifyLoanPayment.vue?vue&type=script&lang=js"
export * from "./ModifyLoanPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports